import { Button, Col, Flex, Form, Input, Layout, Row, Typography } from 'antd'
import { useAttemptListener } from 'dev-masters-react-kit'
import { attemptRegister, RegisterDTO } from '../../utils/redux/authSlice'
import { listenerMiddleware, useAppDispatch } from '../../utils/redux/store'
import './auth.scss'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { LeftOutlined } from '@ant-design/icons'
import LogoImage from '../../assets/logo-image.png'
import WelcomeImage from './assets/welcome-image.jpg'

const { Title } = Typography

export default function Register() {
  const [registerForm] = Form.useForm<RegisterDTO>()
  const dispatch = useAppDispatch()
  const { t } = useTranslation('common')

  function onFinish(values: RegisterDTO) {
    dispatch(attemptRegister(values))
  }

  useAttemptListener({
    listenerMiddleware: listenerMiddleware,
    attempt: attemptRegister,
    onFulfilled: () => {
      console.log('registered successfully')
    },
  })

  return (
    <Layout className="auth auth--register">
      <Flex
        className="auth__outerFlex"
        flex={1}
        justify="center"
        align="center"
        style={{ margin: '3rem 0' }}
      >
        <Row
          className="auth__shell"
          style={{
            width: '80vw',
            borderRadius: '1rem',
            overflow: 'hidden',
          }}
        >
          {/* Desktop / Tablet visual (не трогаем) */}
          <Col span={16}>
            <img
              src={WelcomeImage}
              alt="Welcome"
              style={{ width: '100%', height: '100%', objectFit: 'cover' }}
            />
          </Col>

          {/* Form */}
          <Col
            span={8}
            className="auth__formCol"
            style={{
              padding: '2.5em',
              backgroundColor: '#1C1C1C',
              color: 'white',
            }}
          >
            <div style={{ flexGrow: 1 }}>
              <img
                src={LogoImage}
                alt="MusicTMM"
                style={{ height: '2.5rem', marginBottom: '3.5rem' }}
              />

              <Title
                level={5}
                className="auth__registerTitle"
                style={{
                  textAlign: 'left',
                  marginBottom: 24,
                  color: 'white',
                  fontWeight: 'bold',
                }}
              >
                <Link to="/" className="auth__backLink" aria-label={t('Back')}>
                  <LeftOutlined />
                </Link>
                <span style={{ marginLeft: 8 }}>{t('Create account')}</span>
              </Title>

              <Form
                form={registerForm}
                onFinish={onFinish}
                className="register"
                layout="vertical"
              >
                <Form.Item
                  name="email"
                  label={t('email')}
                  rules={[
                    { required: true, message: 'Please input your email!' },
                    { type: 'email', message: 'Invalid email!' },
                  ]}
                >
                  <Input placeholder={t('email')} />
                </Form.Item>

                <Form.Item
                  name="password"
                  label={t('password')}
                  rules={[{ required: true, message: 'Please input your password!' }]}
                >
                  <Input.Password placeholder={t('password')} />
                </Form.Item>

                <Form.Item
                  name="phone"
                  label={t('phone')}
                  rules={[{ required: true, message: 'Please input your phone!' }]}
                >
                  <Input placeholder={t('phone')} />
                </Form.Item>

                <Form.Item
                  name="name"
                  label={t('Full name')}
                  rules={[{ required: true, message: 'Please input your name!' }]}
                >
                  <Input placeholder={t('name')} />
                </Form.Item>

                <Form.Item
                  name="city"
                  label={t('city')}
                  rules={[{ required: true, message: 'Please input your city!' }]}
                >
                  <Input placeholder={t('city')} />
                </Form.Item>

                <Form.Item
                  name="businessType"
                  label={t('businessType')}
                  rules={[
                    { required: true, message: 'Please input your business type!' },
                  ]}
                >
                  <Input placeholder={t('businessType')} />
                </Form.Item>

                <Form.Item
                  name="identifier"
                  label={t('identifier')}
                  rules={[{ required: true, message: 'Please input your identifier!' }]}
                >
                  <Input placeholder={t('identifier')} />
                </Form.Item>

                <Form.Item className="auth__registerSubmitWrap">
                  <Button type="primary" htmlType="submit" block>
                    {t('register')}
                  </Button>
                </Form.Item>
              </Form>
            </div>
          </Col>
        </Row>
      </Flex>
    </Layout>
  )
}
